import { ITrainingCourseDetailResponse } from '@/types/views/trainingCourse.types';
import { queryKeys } from './queryKeys';
import { useAppQuery } from './useAppQuery';

export const useGetTrainingCourseDetail = (courseId: string | undefined) => {
  return useAppQuery<ITrainingCourseDetailResponse>(
    `/TrainingManager/courses/${courseId}`,
    { enabled: !!courseId, queryKey: queryKeys.trainingCourses.byId(courseId) }
  );
};
